import { SR_API_ACTION_USER_CREATE_STRIPE_CUSTOMER } from 'api/actionTypes';

export default async function createStripeCustomer({ state, apiClient }, { source }) {
  await apiClient.postWithState({
    action: SR_API_ACTION_USER_CREATE_STRIPE_CUSTOMER,
    state: state,
    payload: {
      source,
    },
    onSuccess(stripeCustomerId) {
      state.set(['currentUser', 'stripeCustomerId'], stripeCustomerId);
    },
    onError(error) {
      throw error;
    },
  });
}
